import apiBaseUrl from '../../utils/config.js';

class DoctorClockService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/doctor-clock`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  async getClockStatus(doctorId) {
    const response = await fetch(`${this.baseUrl}/status/${doctorId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${this.getToken()}`,
        'Content-Type': 'application/json',
      }
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch clock status');
    }
    return data;
  }

  async clockIn(doctorId) {
    return this._post(`/clock-in/${doctorId}`);
  }

  async clockOut(doctorId) {
    return this._post(`/clock-out/${doctorId}`);
  }

  async startBreak(doctorId) {
    return this._post(`/start-break/${doctorId}`);
  }

  async endBreak(doctorId) {
    return this._post(`/end-break/${doctorId}`);
  }

  async _post(path) {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${this.getToken()}`,
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'API error');
    }

    return response.json();
  }
  async getTodayLog(doctorId) {
  const response = await fetch(`${this.baseUrl}/logs/today/${doctorId}`, {
    headers: {
      'Authorization': `Bearer ${this.getToken()}`,
      'Content-Type': 'application/json',
    }
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch today’s log');
  }

  return data;
}

}

export default DoctorClockService;
